export default "__VITE_ASSET__TftKPRFo__"